/* eslint-disable max-lines-per-function */

import React, { MouseEvent, useEffect, useMemo, useRef, useState, useCallback } from 'react'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { Box } from '@mui/material'
import useWindow from '@hooks/useWindow'
import PropTypes from 'prop-types'

const AffirmContainer = ({ buttonProps }) =>
  useMemo(() => {
    const html = `
    <style>
      #learn-more-button {
        color: ${buttonProps?.TextColor?.ColorHex || '#fff'};
        height: auto;
        display: flex;
        font-size: ${buttonProps ? '14px' : '1rem'};
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
        text-align: center;
        align-items: center;
        font-weight: ${buttonProps ? '600' : '500'};
        flex-direction: row;
        justify-content: space-evenly;
        background-color: ${buttonProps?.BackgroundColor?.ColorHex || '#0053a0'};
        padding: ${buttonProps ? '5px 20px' : '10px 20px'};
        transition: ${buttonProps ? '250ms cubic-bezier(0.4, 0, 1, 1)' : '250ms cubic-bezier(0.4, 0, 1, 1)'};
        border-color: ${buttonProps ? buttonProps?.BorderColor?.ColorHex || null : '#0053a0'};
        border-style: solid;
        border-width: ${buttonProps?.BorderColor?.ColorHex ? '1px' : '0px'};
        border-radius: ${buttonProps ? buttonProps?.BorderRadius || '4px' : '8px'};
        text-decoration: none;
        position: relative;
        margin: ${buttonProps ? '5px 0' : '10px'};
        cursor: pointer;
        border: ${buttonProps?.BorderColor?.ColorHex ? null : '0'};
        outline: 0;
        user-select: none;
        line-height: ${buttonProps ? '21px' : '24px'};
      }
      #learn-more-button:hover {
        background-color: ${buttonProps ? buttonProps?.BackgroundColorHover?.ColorHex || '#003566' : 'rgb(0, 83, 160)'};
        color: ${buttonProps ? buttonProps?.TextColorHover?.ColorHex || null : '#fff'};
      }
      @media (max-width: 638px) {
        #learn-more-button {
          margin: ${buttonProps ? '5px 0' : '10px 0'};
          width: 100%;
        }
        .finance-affirm-container {
          width: ${buttonProps ? 'fit-content !important' : '100%'};
          margin: ${buttonProps ? '0' : '0 20px'};
        }
      }
    </style>
    <button
      id="learn-more-button"
      class="affirm-product-modal"
      data-page-type="product"
      data-amount="${Math.trunc(1000 * 100)}"
    >
      ${buttonProps?.Text || 'SEE IF YOU QUALIFY'}
    </button>`
    return (
      <div className="finance-affirm-container" suppressHydrationWarning dangerouslySetInnerHTML={{ __html: html }} />
    )
  }, [buttonProps])
// margin: ${buttonProps ? '5px' : '0 20px'};

const AffirmModal = ({ buttonProps }) => {
  const { checkProperty } = useWindow()
  // const { finance, price } = usePriceInfoContext()
  // const priceWithPromoFee = useMemo(() => (price?.value ? price.value * 1.02 : 0), [price.value])
  const [showAffirmPromo, setShowAffirmPromo] = useState(true)
  // const asyncIsPdpAffirnPromotionMessage = useFeatureIsOn('pdp-affirm-promotion-message')

  // const hasFinancingEnabled = finance && finance.period > 0
  // const hasThirdPArtyFinanceEnabled = finance?.hasKlarna && price?.value && price.value > 0

  // this is a proxy for Growthbook async property
  // showAffirmPromo defaults to undefined
  // when resolved it will be true or false and this hook will run again
  // then we use the resolved value to determine if we should show the affirm promo or not
  // useEffect(() => {
  //   if (asyncIsPdpAffirnPromotionMessage) {
  //     setShowAffirmPromo(true)
  //   } else {
  //     setShowAffirmPromo(false)
  //   }
  // }, [])

  const affirmRef = useRef(null)

  useEffect(() => {
    // we want to make sure that the affirm script is loaded before we try to render the affirm component
    if (showAffirmPromo) {
      // if script hasn't load yet, wait for it to load
      checkProperty('affirm').then(() => {
        // if the script is loaded, we can render the affirm component
        if (affirmRef.current) {
          const affirmIsRendered = affirmRef.current.getElementsByClassName('affirm-modal-trigger')
          if (affirmIsRendered.length === 0) {
            window?.affirm?.ui?.refresh()
          }
          Array.from(affirmRef.current.getElementsByClassName('affirm-as-low-as'))?.forEach(element => {
            for (let i = element.childNodes.length - 1; i >= 0; i--) {
              const node = element.childNodes[i]

              // Remove if it's not an <a> element
              if (!(node.nodeType === 1 && node.tagName.toLowerCase() === 'a')) {
                element.removeChild(node)
              }
            }
          })
          Array.from(affirmRef.current.getElementsByClassName('affirm-modal-trigger'))?.forEach(el => {
            el.textContent = 'Check your purchasing power'
          })
        }
      })
    }
  }, [checkProperty, showAffirmPromo])

  // if (showSkeleton && hasFinancingEnabled)
  //   return <div className={cn('h-5 w-72 animate-pulse rounded-md bg-gray-300', skeletonClassName)} />

  return (
    <Box
      ref={affirmRef}
      sx={{
        width: {
          xs: buttonProps ? 'auto !important' : '100%',
          sm: 'auto',
        },
        display: {
          xs: 'flex',
          sm: 'block',
        },
      }}
    >
      <AffirmContainer buttonProps={buttonProps} />
    </Box>
  )
}

AffirmModal.propTypes = {
  buttonProps: PropTypes.object,
}

export default AffirmModal
